<template>
  <div>
    <b-row class="float-right mb-3">
      <span>Exibir</span>
      <select class="ml-2" v-model="rowsPerPage">
        <option
          v-for="pageSize in pageSizeMenu"
          :value="pageSize"
          v-bind:key="pageSize"
        >
          {{ pageSize }}
        </option>
      </select>
      <span class="ml-2 mr-3">Linhas</span>
    </b-row>

    <b-row>
      <p class="mr-3">
        Qual tipo de lançamento deseja verificar as informações?
      </p>
      <b-form-radio-group
        v-model="opcaoSelecionada"
        :options="opcoes"
        class="mb-3"
        value-field="item"
        text-field="name"
      ></b-form-radio-group>
    </b-row>

    <b-table
      select-mode="multi"
      responsive="sm"
      :bordered="true"
      striped
      hover
      selectable
      :small="true"
      :items="items"
      :fields="fields"
      :filter="opcaoSelecionada"
      :filter-function="filtrarPorSituacao"
      :sort-compare="ordenarValores"
      :sort-desc.sync="ordenacaoDecrescente"
      :sort-direction="ordenacaoDirecao"
      :per-page="rowsPerPage"
      :current-page="currentPage"
      @row-clicked="rowClicked"
      show-empty
      empty-filtered-text="Não existe nenhum registro com as informações apresentadas"
      primary-key="id"
    >
      <template #head(selected)>
        <!-- Selecionar -->
        <b-form-checkbox
          disabled
          v-b-tooltip.hover="{ variant: 'primary'}" 
          title="Clique aqui para marcar/desmarcar todos"
          v-model="selectAllRows"
          @click.native="toggleSelect()"
        />
      </template>

      <template #head(ESTADO_LANCAMENTO)>
        <span
          v-b-tooltip.hover.html="{ variant: 'primary'}" 
          title="
           <strong>ATIVO:</strong> Débito ativo é o saldo devedor exigível.<br/><br/><strong>SUSPENSO:</strong> Débito com exigibilidade suspensa por reclamação administrativa ou judicial.">
          Situação
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>

      <template #head(VALOR_CORRIGIDO)>
        <span
          v-b-tooltip.hover="{ variant: 'primary'}" 
          title="Valor principal + Atualizações monetárias até 01/01/2022">
          Valor Corrigido
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>

      <template #head(DESCONTOS)>
        <span
          v-b-tooltip.hover="{ variant: 'primary'}" 
          title="Desconto concedido + Redução de honorários">
          Valor do desconto
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>

      <template v-slot:cell(selected)="{ item, field: { key } }">
        <b-checkbox v-model="item[key]" disabled></b-checkbox>
      </template>

      <template #cell(DSC_ORGAO_COBRANCA)="{ item }">
        <p v-b-tooltip.hover :title="item.DSC_TOOLTIP">
          {{ item.DSC_ORGAO_COBRANCA }}
        </p>
      </template>

      <template #cell(VALOR_CORRIGIDO)="{ item }">
        {{ formatCurrency(item.VALOR_SIMPLES + item.VALOR_CORRECAO) }}
      </template>

      <template #cell(DESCONTOS)="{ item }">
        {{ formatCurrency(item.VALOR_DESCONTO + item.VALOR_DESC_HONORARIO) }}
      </template>

      <template #cell(PAGAMENTO_VISTA)="{ item }">
        {{
          formatCurrency(
            item.VALOR_SIMPLES +
              item.VALOR_CORRECAO +
              item.VALOR_MULTA +
              item.VALOR_JUROS +
              item.VALOR_SELIC +
              item.VALOR_HONORARIO -
              (item.VALOR_DESCONTO + item.VALOR_DESC_HONORARIO)
          )
        }}
      </template>
    </b-table>

    <b-row class="d-flex justify-content-between mx-3">
      <b-col>
        <b>Total de registros: {{ items.length }}</b>
        <br />
        Listando de {{ currentPage }} a
        {{ Math.ceil(items.length / rowsPerPage) }}
      </b-col>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="rowsPerPage"
        aria-controls="my-table"
        align="right"
      >
      </b-pagination>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    fields: Array,
    title: String,
  },
  data() {
    return {
      opcaoSelecionada: "AMBOS",
      opcoes: [
        { item: "ATIVO", name: "Ativos" },
        { item: "SUSPENSO", name: "Suspensos" },
        { item: "AMBOS", name: "Ambos" },
      ],
      selectAllRows: false,
      rowsPerPage: 10,
      pageSizeMenu: [10, 20, 50, 100, 200],
      currentPage: 1,
      ordenarPor: "",
      ordenacaoDecrescente: false,
      ordenacaoDirecao: "asc",
    };
  },
  mounted() {
    this.selectAllRows = false;
    this.clearSelected();
  },
  computed: {
    rows() {
      return this.items.length;
    },
    selecionados() {
      return this.items.filter((item) => item.selected);
    },
  },
  methods: {
    filtrarPorSituacao(item, filter) {
      if (filter === "AMBOS") return true;
      return item.ESTADO_LANCAMENTO.toUpperCase() === filter;
    },
    formatCurrency: function (value) {
      let formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },
    toggleSelect() {
      this.selectAllRows = !this.selectAllRows;

      if (this.selectAllRows === true) this.selectAll();
      else this.clearAll();
    },
    clearSelected() {
      this.selecionados.forEach((item) => {
        this.$set(item, "selected", false);
      });
    },
    clearAll() {
      this.selecionados.push(
        this.items.forEach((item) => {
          this.$set(item, "selected", false);
        })
      );
      this.emitirDados();
    },
    selectAll() {
      this.selecionados.push(
        this.items.forEach((item) => {
          this.$set(item, "selected", true);
        })
      );
      this.emitirDados();
    },
    rowClicked(item) {
      if (item.selected) this.$set(item, "selected", false);
      else this.$set(item, "selected", true);

      this.emitirDados();
    },

    ordenarValores: function (a, b, key) {
     if(key === "VALOR_HONORARIO")
        return a.VALOR_HONORARIO < b.VALOR_HONORARIO ? -1 : a.VALOR_HONORARIO > b.VALOR_HONORARIO ? 1 : 0;
      else if(key === "VALOR_JUROS")
        return a.VALOR_JUROS < b.VALOR_JUROS ? -1 : a.VALOR_JUROS > b.VALOR_JUROS ? 1 : 0;
      else if(key === "VALOR_MULTA")
        return a.VALOR_MULTA < b.VALOR_MULTA ? -1 : a.VALOR_MULTA > b.VALOR_MULTA ? 1 : 0;
      else 
        return null;
    },

    emitirDados() {
      const selecionados = this.selecionados;
      const title = this.title;

      const data = { title, selecionados };

      this.$emit("mostrarSelecionados", data);
    },
  },
};
</script>
